export function shouldRedirectCometHomeToHome({ isCometHomePath, isCometRouteOwner, }) {
    return isCometHomePath && !isCometRouteOwner;
}
export function shouldRedirectCometHomeToMobileNtp({ isCometHomePath, isCometMobile, }) {
    return isCometHomePath && isCometMobile;
}
/**
 * The Comet widget grid is eligible for desktop Comet home sessions. Everyone
 * else gets the base homepage surface.
 */
export function resolveHomePrimarySurface({ isComet, isMobileStyle, areHomeWidgetsEligible, }) {
    if (isComet && !isMobileStyle && areHomeWidgetsEligible)
        return 'comet_widgets';
    return 'base';
}
export function shouldShowCometWidgets(input) {
    return resolveHomePrimarySurface(input) === 'comet_widgets';
}
export function shouldReservePendingHomePrimarySurface({ areHomeWidgetsEligible, hasPrimarySurfaceContentResolved, isMobileStyle, isComet, }) {
    if (hasPrimarySurfaceContentResolved)
        return false;
    const pendingPrimarySurface = resolveHomePrimarySurface({
        areHomeWidgetsEligible,
        isComet,
        isMobileStyle,
    });
    return pendingPrimarySurface === 'comet_widgets';
}
//# sourceMappingURL=resolveHomePrimarySurface.js.map